import { render, staticRenderFns } from "./MessageReactions.vue?vue&type=template&id=7dd1ecc6&scoped=true&"
import script from "./MessageReactions.vue?vue&type=script&lang=js&"
export * from "./MessageReactions.vue?vue&type=script&lang=js&"
import style0 from "./MessageReactions.vue?vue&type=style&index=0&id=7dd1ecc6&lang=less&scoped=true&"
import style1 from "./MessageReactions.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd1ecc6",
  null
  
)

export default component.exports